import Vue from 'vue'

const state = {
    user: {
        uid                                     : null,
        login                                   : null,
        isVerified                              : false,
        email                                   : null,
        phoneNumber                             : null,
        firstName                               : null,
        lastName                                : null,
        otp                                     : false,
        showOtpPage                             : false,
        previousCareerLevel                     : null,
        currentMonthCareerLevel                 : null,
        careerLevel                             : null,
        directBonusCareerLevel                  : null,
        directBonusPosition                     : null,
        frontliners                             : '-',
        lastBusinessBonus                       : '-',
        lastCarBonus                            : '-',
        matchingBonus                           : '-',
        position                                : '-',
        unilevelTeam                            : '-',
        startPacket                             : '-',
        sponsorBonus                            : '-',
        moneyBalance                            : '-',
        street                                  : null,
        city                                    : null,
        postalCode                              : null,
        country                                 : null,
        birthDate                               : null,
        gender                                  : null,
        companyName                             : null,
        companyRegistrationNumber               : null,
        isCompany                               : null,
        isFromUe                                : false,
        has_unilevel_bonus_from_frontliners     : false,
        frontliners_unilevel_group              : null,
        terms_of_use_accepted                   : null
    }
};

const getters = {

    user: state => {
        return state.user
    },

    userFullName:  state => {
        return state.user.firstName + ' ' + state.user.lastName
    }
};

const mutations = {
    /**
     * Set user data
     * @param state
     */
    setUser (state, response) {
        let data = response.data,
            userData = {
                uid                                     : data.user_id,
                login                                   : data.login,
                isVerified                              : data.is_verified,
                email                                   : data.email,
                phoneNumber                             : data.phone_number,
                firstName                               : data.first_name,
                lastName                                : data.last_name,
                otp                                     : false,
                showOtpPage                             : false,
                previousCareerLevel                     : data.previous_career_level,
                currentMonthCareerLevel                 : data.current_month_career_level,
                careerLevel                             : data.career_level,
                directBonusCareerLevel                  : data.direct_bonus_career_level,
                directBonusPosition                     : data.direct_bonus_position,
                frontliners                             : data.frontliners,
                lastBusinessBonus                       : data.last_business_bonus,
                lastCarBonus                            : data.last_car_bonus,
                matchingBonus                           : data.matching_bonus,
                position                                : data.position,
                unilevelTeam                            : data.unilevel_team,
                startPacket                             : data.direct_bonus_position,
                sponsorBonus                            : 0,
                moneyBalance                            : data.money_balance,
                street                                  : data.street,
                city                                    : data.city,
                postalCode                              : data.postal_code,
                country                                 : data.country,
                birthDate                               : data.birth_date,
                future_net_upgrade_account_balance      : data.future_net_upgrade_account_balance,
                gender                                  : data.gender,
                companyName                             : data.company_name,
                companyRegistrationNumber               : data.company_registration_number,
                isCompany                               : data.is_company,
                isFromUe                                : data.is_gdpr_required,
                has_unilevel_bonus_from_frontliners     : data.has_unilevel_bonus_from_frontliners,
                frontliners_unilevel_group              : data.frontliners_unilevel_group,
                terms_of_use_accepted                   : data.terms_of_use_accepted
            };
        Vue.set(state, 'user', userData)
    },

    setOtp (state) {
        Vue.set(state.user, 'otp', true)
    },

    showOtpPage (state) {
        Vue.set(state.user, 'showOtpPage', true)
    },

    hideOtpPage (state) {
        Vue.set(state.user, 'showOtpPage', false)
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js